const img = require('./meiaCalca.png');
const img2 = require('./BALMSTICK.png');
const img3 = require('./glitter.png');
const img4 = require('./glow.png');

export const imgs = {
  meiaCalca: img,
  balmstick: img2,
  glitter: img3,
  glow: img4,
};
